var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _vm._t("text-content"),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label is-required-label" }, [
                  _vm._v("Repair Late Reason"),
                ]),
                _c("div", { staticClass: "control is-extended" }, [
                  _c("div", { staticClass: "select is-fullwidth mb-3" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.value.repairLateReason,
                            expression: "value.repairLateReason",
                          },
                        ],
                        staticClass: "select",
                        attrs: { placeholder: "-Select reason-" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.value,
                              "repairLateReason",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "null" } }, [
                          _vm._v("- Select Late Reason -"),
                        ]),
                        _vm._l(
                          _vm.storeRepairDelayReasons,
                          function (s, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: s.id } },
                              [_vm._v(" " + _vm._s(s.name) + " ")]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    !_vm.$v.entity.repairLateReason.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Repair Late Reason is required"),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Details")]),
                _c("div", { staticClass: "control is-extended" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.value.repairLateReasonDetails,
                        expression: "value.repairLateReasonDetails",
                      },
                    ],
                    staticClass: "textarea",
                    attrs: { placeholder: "Textarea" },
                    domProps: { value: _vm.value.repairLateReasonDetails },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.value,
                          "repairLateReasonDetails",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ],
            2
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _vm.$user.hasEdit(_vm.$route.meta.id) ||
              _vm.$user.hasAdd(_vm.$route.meta.id)
                ? _c(
                    "button",
                    {
                      staticClass: "button is-success tooltip",
                      attrs: { "data-tooltip": "Save & continue" },
                      on: {
                        click: function ($event) {
                          return _vm.saveContinue()
                        },
                      },
                    },
                    [_vm._v("Save & Continue")]
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "button tooltip is-tooltip-topright",
                  attrs: { "data-tooltip": "Don't continue" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }